export default "__VITE_ASSET__NYGRyA5E__"